import { find, get, isNil, reduce } from 'lodash'

export default class GridSelectOptionsHelper {
  constructor(options) {
    this.options = options
    this.values = []

    this.optionsByValue = reduce(options, (hash, option) => {
      this.values.push(option.value)
      return Object.assign(hash, { [option.value]: option })
    }, {})
  }

  valueToText = (value) => {
    return get(this.optionsByValue, `${value}.text`)
  }

  textToValue = (text) => {
    return get(find(this.options, (option) => {
      return option.text === text
    }), 'value')
  }

  // PD-29800: coerces pasted clipboard text (e.g. "Yes"/"No") against declared
  // option text or a round-tripped String(value), instead of storing raw text.
  // Looks up via lodash `find` over the options array, never a bare `obj[text]`
  // lookup, so this method has no prototype-chain access to begin with. The
  // `constructor`/`__proto__` check is defense-in-depth against a future
  // refactor introducing one, not a vector this method is currently exposed to.
  resolvePastedValue = (text) => {
    if (text === 'constructor' || text === '__proto__' || isNil(text) || text === '') {
      return undefined
    }

    const byText = find(this.options, (option) => String(option.text).toLowerCase() === text.toLowerCase())
    if (byText) return byText.value

    return get(find(this.options, (option) => String(option.value) === text), 'value')
  }
}
